"use client";

import { useEffect } from "react";

const VideoConsoleLogger = () => {
    useEffect(() => {
        const loggedUrls = new Set();

        const normaliseUrl = (url) => {
            if (!url) return "";

            try {
                return new URL(url, window.location.href).href;
            } catch {
                return url;
            }
        };

        const isYouTubeUrl = (url) =>
            /youtube\.com|youtu\.be|youtube-nocookie\.com/i.test(url || "");

        const logMedia = () => {
            const mediaList = [];

            // HTML5 videos
            document.querySelectorAll("video").forEach((video, index) => {
                const sourceUrls = Array.from(
                    video.querySelectorAll("source"),
                )
                    .map(
                        (source) =>
                            source.src ||
                            source.getAttribute("src") ||
                            source.getAttribute("data-src"),
                    )
                    .filter(Boolean);

                const src = normaliseUrl(
                    video.currentSrc ||
                        video.src ||
                        video.getAttribute("src") ||
                        video.getAttribute("data-src") ||
                        sourceUrls[0],
                );

                if (src) {
                    loggedUrls.add(src);
                }

                mediaList.push({
                    type: "HTML5 Video",
                    number: index + 1,
                    url: src || "No URL found",
                    poster: video.poster || "",
                });
            });

            // YouTube/Vimeo popup iframes
            document.querySelectorAll("iframe").forEach((iframe, index) => {
                const src = normaliseUrl(
                    iframe.src ||
                        iframe.getAttribute("src") ||
                        iframe.getAttribute("data-src") ||
                        iframe.getAttribute("data-url"),
                );

                if (!src) return;

                const isVideoIframe =
                    isYouTubeUrl(src) ||
                    /vimeo\.com|player\.vimeo\.com/i.test(src);

                if (!isVideoIframe) return;

                loggedUrls.add(src);

                mediaList.push({
                    type: isYouTubeUrl(src)
                        ? "YouTube iframe"
                        : "Vimeo iframe",
                    number: index + 1,
                    url: src,
                    title: iframe.title || "",
                });
            });

            window.allPageVideos = [...loggedUrls];
        };

        // Initial scan
        logMedia();

        // Detect popup iframe insertion and src changes
        const observer = new MutationObserver((mutations) => {
            const mediaChanged = mutations.some((mutation) => {
                if (mutation.type === "attributes") {
                    const target = mutation.target;

                    return (
                        target instanceof HTMLVideoElement ||
                        target instanceof HTMLSourceElement ||
                        target instanceof HTMLIFrameElement
                    );
                }

                return Array.from(mutation.addedNodes).some((node) => {
                    if (!(node instanceof HTMLElement)) {
                        return false;
                    }

                    return (
                        node.matches("video, source, iframe") ||
                        Boolean(
                            node.querySelector(
                                "video, source, iframe",
                            ),
                        )
                    );
                });
            });

            if (mediaChanged) {
                setTimeout(logMedia, 100);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "src",
                "data-src",
                "data-url",
                "href",
            ],
        });

        return () => {
            observer.disconnect();
            delete window.allPageVideos;
        };
    }, []);

    return null;
};

export default VideoConsoleLogger;